<script>
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";
import sitesService from "@/services/sites.js";

export default {
  name: "MoveKiosk",
  data() {
    return {
      kiosk_id: null,
      siteJourney: [],
      site: null,
      area: null,
      kioskId: null,
      selectedIds: null,
      areaOptions: [],
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      update: false,
      action: null,
      hasParent: false,
      sites: [],
      areas: [],
      siteId: null,
      parentId: null,
      isLoading: true,
      disableBtn: true,
      form: {
        area: "",
        site: "",
        journey: "",
        inherit: false,
      },
    };
  },
  validations: {
    form: {
      area: { required },
      site: { required },
      journey: {
        required: requiredIf(function () {
          return !this.form.inherit;
        }),
      },
      inherit: {},
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("sites", ["getSites", "getAreas"]),
    ...mapGetters("journey", ["getJourneys"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("moveKiosk_" + this.kiosk_id);
    },
    async "form.site"(site) {
      this.form.area = "";
      this.form.journey = "";
      // this.siteJourney = this.form.site?.journeys;
      this.fetchJourneyNormalList(site.id);
      await this.fetchAreasBySite(site.id);
    },
    getAreas(getAreas) {
      const { area_id } = this.getModalInfo;
      this.areaOptions = getAreas;
      this.area = getAreas.find((area) => area.id == area_id);
    },
  },
  methods: {
    ...mapActions("sites", [
      "moveKiosk",
      "fetchSites",
      "fetchAreasBySite",
      "fetchMoveKiosk",
    ]),
    ...mapActions("grid", ["getSelectedRows"]),
    ...mapActions("journey", ["fetchJourneyNormalList"]),
    updateDisableBtn(area) {
      if (area.id == this.getModalInfo.area_id) {
        this.disableBtn = true;
      } else {
        this.disableBtn = false;
      }
    },
    async onSubmit() {
      if (this.$v.form.$invalid) return;
      this.submitted = true;
      let singleKiosk = {
        id: this.kioskId,
        params: {
          kiosk: {
            area_id: this.form.area.id,
            journey_id: this.form.inherit
              ? this.form.area.journey_id
              : this.form.journey.id,
          },
        },
      };
      let multipleKiosks = {
        params: {
          kiosk: {
            area_id: this.form.area.id,
            kioskIds: this.selectedIds,
          },
        },
      };
      this.selectedIds
        ? this.$emit(
            "moveMultipleKiosks",
            multipleKiosks,
            `moveKiosk_${this.kiosk_id}`
          )
        : this.$emit(
            "moveSingleKiosk",
            singleKiosk,
            `moveKiosk_${this.kiosk_id}`
          );
    },
  },
  async beforeMount() {
    this.kiosk_id = this.getModalInfo.id;
    const { data: normalSites } = await sitesService.getNormalSites();
    const { data: entitySites } = await sitesService.getSites();

    const { id, site_id, area_id } = this.getModalInfo;
    this.kioskId = id;

    this.sitesWithJourney = normalSites?.filter(
      (site) => site.journeys_count > 0
    );

    if (this.getModalInfo?.parentAreaJourneyId == this.getModalInfo.journey?.id)
      this.form.inherit = true;

    setTimeout(() => {
      this.form.journey = this.getModalInfo.journey;
    }, 0);

    //Find & set site
    this.form.site = entitySites?.find((site) => site.id == site_id);

    this.fetchJourneyNormalList(site_id);

    //Find & set area
    await this.fetchAreasBySite(site_id);
    this.form.area = this.getAreas.find((area) => area.id == area_id);

    this.isLoading = false;
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">
    <h4 class="allareakiosk-header">{{ $t('sitesAndDevices.kioskActions.moveKiosk') }}</h4>
    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="modal-spinner"
    />
    <div v-else>
      <div class="form-groups multi-inputs">
        <!-- site  -->
        <b-form-group>
          <vp-multiselect
            id="site"
            v-model="$v.form.site.$model"
            :options="sitesWithJourney"
            :title="$t('common.site')"
            :showLabel="false"
            label="name"
            :allowEmpty="false"
            :showPlaceholderIcon="true"
            :disabled="submitted"
            zIndex="4"
          />
        </b-form-group>
        <!-- area  -->
        <b-form-group>
          <vp-multiselect
            id="area"
            v-model="$v.form.area.$model"
            :options="areaOptions"
            :title="$t('common.area')"
            :showLabel="false"
            label="name"
            :allowEmpty="true"
            :showPlaceholderIcon="true"
            :disabled="submitted || !areaOptions.length"
            zIndex="3"
          />
          <!-- <p class="vp-ml-3 note" v-if="!areaOptions.length">
            <b>Note: </b>There is no areas in the selected site
          </p> -->
        </b-form-group>

        <!-- Journey -->
        <b-form-group class="move-kiosk-check">
          <b-form-checkbox
            name="check-button"
            :disabled="submitted"
            v-model="$v.form.inherit.$model"
            >{{ $t("sitesAndDevices.inheritJourney")}}</b-form-checkbox
          >
        </b-form-group>

        <div class="form-groups" v-if="!form.inherit">
          <!-- journey  -->
          <b-form-group style="margin-top: 24px">
            <vp-multiselect
              id="jourey"
              v-model="$v.form.journey.$model"
              :title="$tc('common.journey')"
              :options="getJourneys"
              :show-labels="false"
              label="name"
              :allowEmpty="true"
              :showPlaceholderIcon="true"
              :showOptionsBorder="true"
              :disabled="submitted"
            />
          </b-form-group>
        </div>
      </div>
      <div class="actionsline-inside"></div>
      <div class="actions-btns">
        <button
          :disabled="submitted || $v.form.$invalid || !$v.form.$anyDirty"
          class="submit-btn btn btn-primary add-submit"
          size="md"
          @click="onSubmit"
        >
          <i
            v-if="submitted"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          {{ $t('common.move') }}
        </button>
        <button
          class="btn btn-outline-danger cancel-reject"
          :disabled="submitted"
          :class="{ 'cursor-stop': submitted }"
          @click="$bvModal.hide('moveKiosk_' + kiosk_id)"
        >
          {{ $t('common.cancel')}}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep {
  .note {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #939393;
    opacity: 0.8;
  }
  .modal-spinner {
    width: 30px;
    height: 30px;
    position: relative;
    inset-inline-start: 231px;
    margin-bottom: 40px;
  }
}
</style>

<style lang="scss">
div[id*="moveKiosk"] {
  .cursor-stop {
    cursor: not-allowed;
  }
  div[class*="modal-content"] {
    width: 579px;

    border-radius: 26px;
    margin-top: 100px;
    margin-bottom: 50px;
    div[class*="modal-body"] {
      padding: 0px !important;
      .update-user-type-wrapper {
        padding-top: 41px;
        padding-inline-end: 0px;
        padding-bottom: 0px;
        padding-inline-start: 46px;
        h4.allareakiosk-header {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
          margin-top: 0px;
          margin-inline-end: auto;
          margin-bottom: 51px;
          margin-inline-start: 0px;
          text-align: center;
        }
        .move-kiosk-check {
          width: 346px;
          margin: 8px auto 0px auto;
        }
        .multi-inputs {
          input#area,
          input#journey,
          input#site {
            background: #f2f2f2 !important;
            &::placeholder {
              font-weight: 700;
              font-size: 16px;
              line-height: 17px;
              letter-spacing: 0.25px;
              color: rgba(0, 0, 0, 0.87);
              opacity: 0.8;
            }
          }
        }

        .actionsline-inside {
          background: #707070;
          height: 1px;
          opacity: 0.15;
          margin-top: 43px;
          margin-bottom: 20px;
          margin-inline-end: 36px !important;
        }
        .actions-btns {
          margin-inline-end: 36px;
          // background: red;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          justify-content: center;
          .submit-btn {
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
            color: #ffffff !important;
            margin-inline-end: 15px !important;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cancel-reject {
            margin-inline-start: 15px;
            width: 111px !important;
            height: 33px !important;
            border-radius: 16px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400 !important;
            font-size: 16px !important;
            line-height: 19px !important;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
